import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import head from "./modules/head";
import getters from "./getters";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user,
        head
    },
    getters
})
